import React, {useEffect, useState, useRef} from 'react';
import Axios from 'axios';
import { Alert } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import '../App.css';
import Pagination from '../components/global/Paginator'
import {exportToExcel} from "../utils/reports/exportToExcel";
import {formatDate} from "../utils/dates";

function Grillaboordersreports (props){
    const fileInputRef = useRef();
    const searchInput = useRef(null);
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [datos, setDatos] = useState([]);
    const [datosDetalle, setDatosDetalle] = useState([]);
    const [datosDetalleComanda, setDatosDetalleComanda] = useState([]);
    const [datosBackup, setDatosBackup] = useState([])
    const [datosExport, setDatosExport] = useState([]);
    const [fecha, setFecha] = useState('')
    const [visible, setVisible] = useState('seccionNoVisible')
    const [visible1, setVisible1] = useState('seccionNoVisible')
    const [beneficiariobyuser, setBeneficiariobyuser] = useState([])
    const [beneficiario, setBeneficiario] = useState()
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);

    const [tituloAlert1, setTituloAlert1] = useState('')
    const [textoAlert1, setTextoAlert1] = useState('')
    const [claseAlert1, setClaseAlert1] = useState('')
    const [alert1, setAlert1] = useState(false);    

    const [pageNumber, setPageNumber] = useState('')
    const [pageSize, setPageSize] = useState(3);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);   
    const [typeUser, setTypeUser] = useState('Apoderado')
    const [fecha_desde, setFechaDesde] = useState('')
    const [fecha_hasta, setFechaHasta] = useState('')

    

    // Referencia para el número de página (evitar estados desincronizados)
    const pageRef = useRef(currentPage);
 

    let statuscall = '' 
    
const dataList = Array.isArray(datos) && datos.length > 0
  ? datos.map((item, i) => (
      <tr key={item.id ?? i} className="divide-y divide-gray-100 bg-white">
        <td className="px-6 py-4 whitespace-nowrap text-sm">{item.id}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm">{item.user_id}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm">{item.casino_id}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm">{item.nombre_casino}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm">{item.fecha_creacion}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm">$ {item.total_compra}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm">
          <button
            className="text-indigo-600 hover:underline text-sm"
            onClick={() => verDetalleCompra(item.id)}
          >
            Detalle Compra
          </button>
              -
          <button
            className="text-indigo-600 hover:underline text-sm"
            onClick={() => verDetalleComanda(item.comanda_id)}
          >
            Detalle Comanda
          </button>          
        </td>
      </tr>
    ))
  : (
      // opcional: fila vacía o mensaje cuando no hay datos
      <tr>
        <td className="px-6 py-4 text-sm text-gray-500" colSpan={7}>
          Sin resultados
        </td>
      </tr>
    );


    const dataListDetalle = Array.isArray(datosDetalle) && datosDetalle.length > 0
    ?  datosDetalle.map((item, i) => (
        <tr key={item.id ?? i} className="divide-y divide-gray-100 bg-white">
            <td className="px-6 py-4 whitespace-nowrap text-sm">{item.id}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">{item.compra_id}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">{item.producto_cafeteria_id}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">{item.nombre}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">$ {item.precio}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">{item.cantidad_producto}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">% {item.descuento}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">$ {item.total_fila}</td>
        </tr>
    )):[]

    const dataListDetalleComanda = Array.isArray(datosDetalleComanda) && datosDetalleComanda.length > 0
    ?  datosDetalleComanda.map((item, i) => (
        <tr key={item.id ?? i} className="divide-y divide-gray-100 bg-white">
            <td className="px-6 py-4 whitespace-nowrap text-sm">{item.linea_detalle}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">{item.comanda_id}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">{item.nombre}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">$ {item.precio}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">{item.cantidad_producto}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm">{item.estado}</td>
        </tr>
    )):[]

    const handleFechaDesde = (e) => {
        setFechaDesde(e.target.value)
    }

    const handleFechaHasta = (e) => {
        setFechaHasta(e.target.value)
    }

    const handleExport = () => {
        console.log("Export")
        const date = new Date();

        // Formateamos la fecha en formato yyyy-mm-dd
        const formattedDate = date.toISOString().split('T')[0];

        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        console.log("Casino en reporte excel : " + idcasino)
        Axios.get(process.env.REACT_APP_URLWALLETCOMPRAREPORTEEXCEL, {
            params: {
                casino_id: idcasino.replace('"', ''),
                fecha_desde: fecha_desde || formattedDate,
                fecha_hasta: fecha_hasta || formattedDate           
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            const formattedData = response.data.compras.map((compras) => ({
                ID_Compra: compras.id,
                ID_Usuario: compras.user_id,
                ID_Casino: compras.casino_id,
                Nombre_Casino: compras.nombre_casino,
                Fecha_Creacion: compras.fecha_creacion,
                Total_Compra: compras.total_compra
            }))
            exportToExcel(formattedData, `ReporteCompras_${formatDate()}.xlsx`, "Compras");

            //setDatosExport(formattedData)
 
        }).catch(error => {
            console.log("Error en excel: " + error)
            return error     
        });

    };

    const handlePageSize = (e) => {
        setPageSize(e.target.value)
    }

    const GetCompras = () =>
    {
        const date = new Date();

        // Formateamos la fecha en formato yyyy-mm-dd
        const formattedDate = date.toISOString().split('T')[0];

        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        Axios.get(process.env.REACT_APP_URLWALLETREPORTECOMPRA, {
            params: {
                page: pageNumber || 1,
                pageSize: pageSize || 10,
                casino_id: idcasino.replace('"', ''),
                fecha_desde: fecha_desde || formattedDate,
                fecha_hasta: fecha_hasta || formattedDate
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            
            setDatos(response.data.compras)
            setDatosBackup(response.data.compras)

            setCurrentPage(response.data.compras_metadata.currentPage)
            setPageNumber(response.data.compras_metadata.currentPage)

            setTotalPages(response.data.compras_metadata.totalPages)
        }).catch(error => {
            return error     
        });
    }

    const verDetalleCompra= (compra_id) =>{

        Axios.get(process.env.REACT_APP_URLWALLETDETALLECOMPRA, {
            params: {
                compra_id: compra_id
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatosDetalle(response.data.compra_detalle)

        }).catch(error => {
            return error     
        });

        handleShow()
    }
         
    const verDetalleComanda= (comanda_id) =>{

        Axios.get(process.env.REACT_APP_URLWALLETDETALLECOMANDA, {
            params: {
                comanda_id: comanda_id
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatosDetalleComanda(response.data.comanda_detalle)

        }).catch(error => {
            return error     
        });

        handleShow1()
    }

    useEffect(() => {
        GetCompras()

    }, [pageNumber]);


    const handleClose = () => {
        setBeneficiario('')
        setFecha('')
        setShow(false)
    }

    const handleClose1 = () => {
        setBeneficiario('')
        setFecha('')
        setShow1(false)
    }    

    const handleShow = () => setShow(true)
    const handleShow1 = () => setShow1(true)

    const handleChangeList= (e) => {
        let text = e.target.value;
        const setBusqueda = e.target.value;
        const data = datosBackup
        const newData = data.filter(
            function(item){
                const itemDataUsuario = String(item.id ?? '');
                const itemUser        = String(item.user_id ?? '');
                const itemCasino      = String(item.nombre_casino ?? '');
                const itemFecha       = String(item.fecha_creacion ?? '');
                const campo = (itemDataUsuario + ' ' + itemUser + ' ' + itemCasino + ' ' + itemFecha).toLowerCase();
                const textData = String(text ?? '').toLowerCase();
                return campo.indexOf(textData) > -1;         
            }
        )
        setDatos(newData)
    }


    const handleTypeUser = (e) => {
        setTypeUser(e.target.value)
    }



    return(
    <div className='w-full'>
        {/* Zona 1 - Filtros */}
        <div className="bg-white shadow-lg p-6 mx-4 mb-2">


        {/* Zona 1 - Header con Título y Filtros */}
        <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
        <h1 class="text-2xl font-bold">Reporte Ordenes</h1>

        <div class="flex flex-wrap gap-4">

                {/* Campo Fecha Inicio */}
                <div className="flex flex-col">
                    <input
                    value={fecha_desde} 
                    onChange={handleFechaDesde}
                    type="date" 
                    id="fechaInicio"
                    placeholder='Fecha Inicio' 
                    className="p-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Campo Fecha Fin */}
                <div className="flex flex-col">
                    <input
                    value={fecha_hasta} 
                    onChange={handleFechaHasta}
                    type="date" 
                    id="fechaFin"
                    placeholder='Fecha Fin' 
                    className="p-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Campo Selección Número de Páginas */}
                <div className="flex flex-col">
                    <input 
                    type="number" 
                    id="numeroPaginas"
                    placeholder='Registros por pagina'
                    value={pageSize}
                    onChange={handlePageSize} 
                    min="1" 
                    step="1" 
                    defaultValue="1" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                </div>

                {/*Buscador*/}
                <div class="relative">
                <input type="text" 
                    placeholder="Buscar en grilla" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    id="Buscar en grilla"
                    onChange={handleChangeList}  />
                <div class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35m1.4-5.4a7 7 0 11-14 0 7 7 0 0114 0z"/>
                    </svg>
                </div>
                </div>

                {/* Botón generar reporte */}
                <button
                    onClick={GetCompras}
                    className="flex items-center gap-2 bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium px-4 py-2 rounded-lg shadow"
                    >
                    <svg
                        className="w-4 h-4 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 4H7a2 2 0 01-2-2V6a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2z"
                        />
                    </svg>
                    <span>Generar Reporte</span>
                </button>

                {/*Botón Exportar a Excel*/}
                <button onClick={handleExport} class="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium px-4 py-2 rounded-lg shadow">
                <svg class="w-4 h-4 fill-current text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M384 121.9V128H272V0H128C92.7 0 64 28.7 64 64v384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160h64v-38.1c0-13.1-10.6-23.9-23.7-23.9H384zM299.1 272l-42.1 48 42.1 48H258l-26.5-31.1L205 368h-40.5l42.1-48-42.1-48H205l26.5 31.1L258 272h41.1z"/>
                </svg>
                <span>Export</span>
                <svg class="w-4 h-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4" />
                </svg>
                </button>


        </div>
        </div>
        </div>




        {/* Zona 2 */}
        <div className="bg-white shadow-lg p-4 mx-4 mb-2">
            {/* Controles de Búsqueda y Exportar */}
            <div className="overflow-y-auto h-[600px] p-4">
                {/* Contenedor para los detalles de los tickets */}
                <div className="space-y-6">
                    <div class="bg-white shadow rounded-2xl overflow-hidden">
                        <div class="max-h-96 overflow-y-auto">
                            <table class="min-w-full table-auto">
                            <thead class="bg-gray-50 sticky top-0 z-10">
                                <tr>
                                    <th class="px-6 py-4 whitespace-nowrap text-sm">Id Compra</th>
                                    <th class="px-6 py-4 whitespace-nowrap text-sm">Usuario</th>
                                    <th class="px-6 py-4 whitespace-nowrap text-sm">Id Casino</th>
                                    <th class="px-6 py-4 whitespace-nowrap text-sm">Nombre Casino</th>
                                    <th class="px-6 py-4 whitespace-nowrap text-sm">Fecha Creacion</th>
                                    <th class="px-6 py-4 whitespace-nowrap text-sm">Total Compra</th>
                                    <th class="px-6 py-4 whitespace-nowrap text-sm">Acciones</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-100 bg-white">
                                {dataList}
                            </tbody>
                            </table>
                        </div>

                        {/*Paginación*/} 
                        <div class="flex items-center justify-between mt-6">
                            <div class="inline-flex items-center space-x-2">
                            <Pagination currentPage={pageNumber} totalPages={totalPages} onPageChange={setPageNumber}/>            
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>        


        <Modal show={show} onHide={handleClose} size="lg" fullscreen>
        <Modal.Header closeButton>
            <Modal.Title>Detalle Compra</Modal.Title>
        </Modal.Header>

        {/* Hacemos el body scrollable horizontalmente por si la tabla es ancha */}
        <Modal.Body style={{ overflowX: 'auto' }}>
            <div className="row divAbsolute">
            <div className="col col-lg-12">
                {alert ? (
                <Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                    <Alert.Heading>{tituloAlert}</Alert.Heading>
                    <p>{textoAlert}</p>
                </Alert>
                ) : (
                ''
                )}
            </div>
            </div>

            {/* Contenedor con scroll horizontal y altura razonable */}
            <div className="w-full overflow-x-auto">
            <table className="min-w-full table-auto border-collapse">
                <thead className="bg-gray-50 sticky top-0 z-10">
                <tr>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Id</th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Id Compra</th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Id Producto</th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Nombre Producto</th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Precio</th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Cantidad</th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Descuento</th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Total Fila</th>
                </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 bg-white">
                {dataListDetalle}
                </tbody>
            </table>
            </div>
        </Modal.Body>

        <Modal.Footer>
            <button onClick={handleClose}>Cerrar</button>
        </Modal.Footer>

        <Modal.Footer className={visible}>
            <div>
            <h4></h4>
            </div>
        </Modal.Footer>
        </Modal>

        <Modal show={show1} onHide={handleClose1} size="lg" fullscreen>
        <Modal.Header closeButton>
            <Modal.Title>Detalle Comanda</Modal.Title>
        </Modal.Header>

        {/* Hacemos el body scrollable horizontalmente por si la tabla es ancha */}
        <Modal.Body style={{ overflowX: 'auto' }}>
            <div className="row divAbsolute">
            <div className="col col-lg-12">
                {alert ? (
                <Alert variant={claseAlert1} onClose1={() => setAlert1(false)} dismissible fade show>
                    <Alert.Heading>{tituloAlert1}</Alert.Heading>
                    <p>{textoAlert1}</p>
                </Alert>
                ) : (
                ''
                )}
            </div>
            </div>

            {/* Contenedor con scroll horizontal y altura razonable */}
            <div className="w-full overflow-x-auto">
            <table className="min-w-full table-auto border-collapse">
                <thead className="bg-gray-50 sticky top-0 z-10">
                <tr>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Linea Detalle</th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Id Comanda</th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Producto</th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Precio</th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Cantidad</th>
                    <th className="px-6 py-4 whitespace-nowrap text-sm">Estado</th>
                </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 bg-white">
                {dataListDetalleComanda}
                </tbody>
            </table>
            </div>
        </Modal.Body>

        <Modal.Footer>
            <button onClick={handleClose1}>Cerrar</button>
        </Modal.Footer>

        <Modal.Footer className={visible1}>
            <div>
            <h4></h4>
            </div>
        </Modal.Footer>
        </Modal>                                                                                                                                                                                     
    </div>    
    )
}
export default Grillaboordersreports